import { DriverSearchInvoiceInput } from '@allocab/allocab-driver-shared-types';
import { InvoiceV2Output } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

export const INVOICE_LIMIT = 20;

type Input = Omit<DriverSearchInvoiceInput, 'offset' | 'limit'> & { limit?: number };

const fetchInvoices = (input: DriverSearchInvoiceInput) =>
  driverApi.post<DriverSearchInvoiceInput, InvoiceV2Output, 'list'>(`/v2/invoice/search`, input);

export const useFethInvoicesPage = (input: Input, pageNumber = 1) => {
  const limit = input.limit ?? INVOICE_LIMIT;
  const apiInput: DriverSearchInvoiceInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  return useQuery(queryKeys.user.fetchInvoices(apiInput), () => fetchInvoices(apiInput), { keepPreviousData: true });
};
